<template>
	<v-card class="notifocation-group-users-view-card">
		<egranty-table
			:table-name="tableName"
			:toolbar-action-name="'Dodaj użytkownika'"
			:toolbar-action-visible="roles.isAdministrator() || roles.isLocalAdministrator()"
			:headers="headers"
			:items="users"
			:row-actions="actions"
			:row-actions-visible="roles.isAdministrator() || roles.isLocalAdministrator()"
			@toolbarAction="addGroupUser"
			@deleteUser="(item) => {deleteGroupUser(item.id)}">
		</egranty-table>

		<v-dialog v-model="autocompleteDialog" max-width="800px">
			<v-card>
				<v-card-title class="headline primary">
					Dodaj użytkownika do grupy
				</v-card-title>
				<v-card-text>
					<v-autocomplete
						v-model="chosenRole"
						:items="systemRoles"
						label="Rola systemowa"
						aria-label="system role"
						for="notiifcation-group-users-view-system-role"
						id="notiifcation-group-users-view-system-role"
						item-text="name"
						item-value="value"
						hide-no-data
						hide-selected>
					</v-autocomplete>

					<div v-if="chosenRole !== null && hasOrganizationName">
						<v-autocomplete
							v-model="chosenOrganization"
							:items="organizations"
							label="Nazwa organizacji"
							aria-label="organization name"
							for="notiifcation-group-users-view-organization-name"
							id="notiifcation-group-users-view-organization-name"
							item-text="polishName"
							item-value="id"
							hide-selected>
						</v-autocomplete>
						<v-expand-transition>
							<v-list v-if="chosenOrganization !== null" class="grey lighten-2">
								<v-list-tile
									v-for="(field, i) in bidderFields"
									:key="i">
									<div>
										<v-list-tile-content v-if="field.key !== 'id'">
											<v-list-tile-sub-title v-text="field.key + ':'"></v-list-tile-sub-title>
											<v-list-tile-title v-text="field.value"></v-list-tile-title>
										</v-list-tile-content>
									</div>
								</v-list-tile>
							</v-list>
						</v-expand-transition>
					</div>

					<div v-if="chosenRole !== null && !hasOrganizationName">
						<v-autocomplete
							v-model="chosenUser"
							:items="usersWithoutOrganization"
							label="Użytkownik"
							aria-label="notification group user"
							for="notiifcation-group-users-view-user"
							id="notiifcation-group-users-view-user"
							item-text="fullUserName"
							item-value="id"
							hide-selected>
						</v-autocomplete>
						<v-expand-transition>
							<v-list v-if="chosenUser !== null" class="grey lighten-2">
								<v-list-tile
									v-for="(field, i) in userFields"
									:key="i">
									<v-list-tile-content v-if="field.key !== 'id'">
										<v-list-tile-sub-title v-text="field.key + ':'"></v-list-tile-sub-title>
										<v-list-tile-title v-text="field.value"></v-list-tile-title>
									</v-list-tile-content>
								</v-list-tile>
							</v-list>
						</v-expand-transition>
					</div>

					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							:disabled="chosenOrganization === null && chosenUser === null"
							color="primary"
							@click="saveGroupUser(chosenOrganization, chosenUser)"
						>
							Zapisz
						</v-btn>
						<v-btn
							:disabled="chosenRole === null"
							color="blue"
							@click="clearFields"
						>
							Resetuj
						</v-btn>
						<v-btn
							color="blue"
							@click="autocompleteDialog = false"
						>
							Anuluj
						</v-btn>
					</v-card-actions>

				</v-card-text>
				<v-divider></v-divider>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
	import {Notification} from "@/api/generated/Notification";
	import {Bidder} from "@/api/generated/Bidder";
	import {User} from "@/api/generated/User";
	import EgrantyTable from "../../../../genericComponents/EgrantyTable";

	export default {
		name: "NotificationGroupUsersView",
		components: {EgrantyTable},

		data() {
			return {
				groupName: "",

				headers: [
					{text: "Imię", value: "name", sortable: false},
					{text: "Nazwisko", value: "surname", sortable: false},
					{text: "E-mail", value: "email", sortable: false},
					{text: "Rola systemowa", value: "systemRole", sortable: false},
				],

				userHeaders: {
					name: "Imię",
					surname: "Nazwisko",
					email: "E-mail",
					systemRole: "Rola systemowa",
				},

				users: [],

				usersToAdd: [],

				userInfo: null,

				bidderInfo: null,

				actions: [
					{name: "deleteUser", icon: "delete"},
				],

				autocompleteDialog: false,

				chosenRole: null,

				chosenOrganization: null,

				chosenUser: null,

				systemRoles: [
					{value: "ADMINISTRATOR", name: "Administrator główny"},
					{value: "LOCAL_ADMINISTRATOR", name: "Administrator lokalny"},
					{value: "DEPARTMENT_EMPLOYEE", name: "Pracownik departamentu"},
					{value: "AGENCY_EMPLOYEE", name: "Pracownik placówki"},
					{value: "EXPERT", name: "Ekspert"},
					{value: "BIDDER", name: "Oferent - konto główne"},
					{value: "SUB_BIDDER", name: "Oferent - subkonto"},
					{value: "VOLUNTEER", name: "Wolontariusz"},
					{value: "VIEWER", name: "Przeglądający"},
				],

				organizations: [],
			};
		},

		methods: {
			refresh() {
				getGroupName(this);
				getGroupUsers(this);
			},

			addGroupUser() {
				this.autocompleteDialog = true;
			},

			saveGroupUser(chosenOrganization, chosenUser) {
				if (chosenOrganization !== null) {
					saveNotificationGroupUser(this, chosenOrganization);
				} else {
					saveNotificationGroupUser(this, chosenUser);
				}
			},

			deleteGroupUser(userId) {
				this.$confirm("Czy na pewno chcesz usunąć użytkownika z grupy?", {
					color: "lightred",
					icon: "delete",
					title: "Usunięcie użytkownika",
					width: 500
				})
					.then(res => {
						if (res) {
							deleteNotificationGroupUser(this, userId);
						}
					});
			},

			clearFields() {
				this.chosenRole = null;
				this.chosenOrganization = null;
				this.chosenUser = null;
			},

			processDepartmentName() {
				return this.userInfo["department"] !== null ? this.userInfo["department"].name || "-" : "-";
			},

			processSystemRoles(users) {
				users.map(item => {
					item.systemRole = this.systemRoles.filter(role => role.value === item.systemRole)[0]["name"];
				});
			},
		},

		computed: {
			tableName() {
				return "Użytkownicy grupy " + this.groupName;
			},
			hasOrganizationName() {
				return this.chosenRole === "BIDDER" || this.chosenRole === "SUB_BIDDER";
			},
			hasDepartment() {
				return this.chosenRole === "LOCAL_ADMINISTRATOR" || this.chosenRole === "DEPARTMENT_EMPLOYEE";
			},
			usersWithoutOrganization() {
				return this.usersToAdd.map(user => {
					const fullUserName = user.name + " " + user.surname;
					return Object.assign({}, user, {fullUserName});
				});
			},
			bidderFields() {
				if (!this.bidderInfo) return [];
				return Object.keys(this.bidderInfo).map(key => {
					return {
						key: key === "name" ? "Imię" :
							key === "surname" ? "Nazwisko" :
							key === "email" ? "E-mail" :
							key === "systemRole" ? "Rola systemowa" :
							key === "polishName" ? "Nazwa organizacji" :
							key,
						value: this.bidderInfo[key] || "-",
					};
				});
			},
			userFields() {
				if (!this.userInfo) return [];
				return Object.keys(this.userInfo).map(key => {
					return {
						key: key === "name" ? "Imię" :
							key === "surname" ? "Nazwisko" :
							key === "email" ? "E-mail" :
							key === "systemRole" ? "Rola systemowa" :
							key === "department" ? "Departament" :
							key,
						value: key === "department" ? this.processDepartmentName() : this.userInfo[key] || "-",
					};
				});
			},
		},

		created() {
			this.refresh();
		},

		watch: {
			autocompleteDialog(value) {
				if (value === false) this.clearFields();
			},

			chosenRole(value) {
				if (value !== null) {
					if (this.chosenRole === "BIDDER") {
						getBidderOrganizations(this);
					} else if (this.chosenRole === "SUB_BIDDER") {
						getSubBidderOrganizations(this);
					} else if (this.hasDepartment) {
						getDepartmentUsersToAdd(this);
					} else {
						getUsersToAdd(this);
					}
				}
				this.chosenOrganization = null;
				this.chosenUser = null;
			},

			chosenOrganization(value) {
				if (value !== null) {
					if (this.chosenRole === "BIDDER") {
						getBidderData(this);
					} else if (this.chosenRole === "SUB_BIDDER") {
						getSubBidderData(this);
					}
				}
			},

			chosenUser(value) {
				if (value !== null) {
					getUserData(this);
				}
			},
		},
	};

	function getGroupName(ctx) {
		Notification.getGroupName(ctx, ctx.$route.params.groupId, successResponse => {
				ctx.groupName = successResponse.name;
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować nazwy grupy", errorResponse);
			});
	}

	function getGroupUsers(ctx) {
		Notification.getGroupUsers(ctx, ctx.$route.params.groupId, successResponse => {
				ctx.users = successResponse;
				ctx.processSystemRoles(ctx.users);
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować użytkowników grupy", errorResponse);
			});
	}

	function getBidderOrganizations(ctx) {
		Bidder.getBidderPolishOrganizationNames(ctx, ctx.$route.params.groupId, successResponse => {
				ctx.organizations = successResponse;
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować nazwy organizacji", errorResponse);
			});
	}

	function getSubBidderOrganizations(ctx) {
		Bidder.getSubBidderPolishOrganizationNames(ctx, ctx.$route.params.groupId, successResponse => {
				ctx.organizations = successResponse;
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować nazwy organizacji", errorResponse);
			});
	}

	function getUsersToAdd(ctx) {
		Notification.getUsersToAdd(ctx, ctx.chosenRole, ctx.$route.params.groupId, successResponse => {
				ctx.usersToAdd = successResponse;
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować listę użytkowników", errorResponse);
			});
	}

	function getDepartmentUsersToAdd(ctx) {
		Notification.getDepartmentUsersToAdd(ctx, ctx.chosenRole, ctx.$route.params.departmentId, ctx.$route.params.groupId, successResponse => {
				ctx.usersToAdd = successResponse;
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować listę użytkowników", errorResponse);
			});
	}

	function getUserData(ctx) {
		User.getUserNotificationGroupData(ctx, ctx.chosenUser, successResponse => {
				ctx.userInfo = successResponse;
				ctx.userInfo.systemRole = ctx.systemRoles.filter(role => role.value === ctx.userInfo.systemRole)[0]["name"];
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować danych użytkownika", errorResponse);
			});
	}

	function getBidderData(ctx) {
		Bidder.getBidderData(ctx, ctx.chosenOrganization, successResponse => {
				ctx.bidderInfo = successResponse;
				ctx.bidderInfo.systemRole = ctx.systemRoles.filter(role => role.value === ctx.bidderInfo.systemRole)[0]["name"];
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować danych oferenta", errorResponse);
			});
	}

	function getSubBidderData(ctx) {
		Bidder.getSubBidderData(ctx, ctx.chosenOrganization, successResponse => {
				ctx.bidderInfo = successResponse;
				ctx.bidderInfo.systemRole = ctx.systemRoles.filter(role => role.value === ctx.bidderInfo.systemRole)[0]["name"];
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się załadować danych oferenta", errorResponse);
			});
	}

	function saveNotificationGroupUser(ctx, id) {
		Notification.postNotificationGroupUser(ctx, {
				userId: id,
				notificationGroupId: ctx.$route.params.groupId,
			}, successResponse => {
				ctx.$messagesBus.$emit("success", "Użytkownik został pomyślnie zapisany", successResponse);
				ctx.autocompleteDialog = false;
				ctx.refresh();
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się zapisać użytkownika", errorResponse);
			});
	}

	function deleteNotificationGroupUser(ctx, id) {
		Notification.deleteNotificationGroupUser(ctx, id, ctx.$route.params.groupId, successResponse => {
				ctx.$messagesBus.$emit("success", "Użytkownik został pomyślnie usunięty", successResponse);
				ctx.refresh();
			},
			errorResponse => {
				ctx.$messagesBus.$emit("error", "Nie udało się usunąć użytkownika", errorResponse);
			});
	}

</script>

<style scoped>
	.notifocation-group-users-view-card .v-list__tile {
		height: 48px;
	}

</style>
